import replace from "ramda/src/replace";
import toUpper from "ramda/src/toUpper";

export const capitalize = replace(/^./, toUpper);
